export default function disableFontFeatureSetting(
    content: string,
    tag: string,
): string {
    const regex = new RegExp(`('|"|&quot;)${tag}\\1`, 'gmi');
    return content.replace(regex, `$1${tag}$1 0`);
}
